import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type * as Posts from '../../../shared/domain/posts/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/posts' }

type Params = never
type Body = never
type Query = {
    id: UUID[] | UUID
    excludeFiles?: boolean
    includeLanguage?: boolean
    language?: string

    // If true, the response will indicate whether the report post can be invalidated
    reportCanBeInvalidated?: boolean
}
type Output = { posts: Posts.SyncPost[] }

export type GetEndpoint = Endpoint<Params, Body, Query, Output>

export const getRequest = (request: Request, args: RequestArgs<GetEndpoint>) => request<GetEndpoint>(route, args)
